var map = {
	"./danielaRizzi.jpg": "12a7",
	"./danielaRizzi@2x.jpg": "859b",
	"./dariaPushkova.jpg": "00e6",
	"./dariaPushkova@2x.jpg": "ed2f",
	"./flaminiaGiorda.jpg": "f736",
	"./flaminiaGiorda@2x.jpg": "111c",
	"./marinaLoshak.jpg": "216c",
	"./marinaLoshak@2x.jpg": "b517",
	"./teresaIarocciMavica.jpg": "b535",
	"./teresaIarocciMavica@2x.jpg": "e576"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b2e";